import React from "react";
import _ from "lodash";
import PropTypes from "prop-types";
import Modal from "../modal";
import UnitInput from "../inputs/unit-input";
import { getUserToRequest } from "../../views/dashboard/settings/manage-coaches/utils/manage-coaches-utils";

class EditSetsModal extends React.Component {
  render() {
    const { locals } = this.context;
    const { activeUser, editExercise, query,organizationOwner } = locals;
    const userToMeasure = getUserToRequest(activeUser, organizationOwner);
    const index = _.get(query, "modal.index", _.size(editExercise.sets));
    const isNew = !_.has(query, "modal.index");
    const primary = _.get(query, "primary");
    const set = isNew ? {} : editExercise.sets[index];
    const isAssistant = _.get(query, "type") === "assistant";
    const defaultRepMax = _.get(
      editExercise,
      `repMaximums.${primary}`,
      _.get(activeUser, `repMaximums.${primary}`, 0)
    );
    const preferredLoadInput = _.get(
      userToMeasure,
      "preferredLoadInput",
      "percent"
    );
    const percentRM = _.round((set.load / defaultRepMax) * 100, 1);

    let tabIndex = 1;

    return (
      <form
        name="editSets"
        key={index}
        method="POST"
        action={`/actions/exercise/sets/save/${index}/${editExercise._id}`}
        data-noreset
        name="edit-set"
      >
        <Modal width="600px">
          <input type="hidden" name="index" value={index} />

          <div className="head">
            <h2 className="alt">{isNew ? "ADD SET" : "EDIT SET"}</h2>
          </div>

          <div className="body">
            <div className="columns">
              <div className="column" data-col="1/3">
                <div className="label">Sets</div>
                <input
                  autoFocus
                  tabIndex={tabIndex++}
                  required
                  type="number"
                  name="sets"
                  step="1"
                  min="1"
                  className="text-input"
                  defaultValue={set.sets || ""}
                />
              </div>

              <div className="column" data-col="1/3">
                <div className="label">Reps</div>
                <input
                  required
                  type="number"
                  tabIndex={tabIndex++}
                  name="reps"
                  step="1"
                  min="1"
                  className="text-input"
                  defaultValue={set.reps || ""}
                />
              </div>

              <div className="column" data-col="1/3">
                <div className="label">RPE</div>
                <select
                  name="rpe"
                  className="select-input"
                  tabIndex={tabIndex++}
                  defaultValue={set.rpe || ""}
                >
                  <option value="">RPE</option>
                  {_.map(_.reverse(_.range(4, 9.5, 0.5)), (i) => (
                    <option key={i} value={i + 1}>
                      {i + 1}
                    </option>
                  ))}
                  <option value="AMRAP">AMRAP</option>
                </select>
              </div>

              <div className="column" data-col="2/3">
                <div className="label">Load</div>
                {isAssistant ? (
                  <div className="Load-Selector">
                    <div>
                      <input
                        type="radio"
                        name="loadType"
                        id="load-weight"
                        defaultValue="weight"
                        defaultChecked
                      />
                      <div className="load">
                        <UnitInput
                          metric="kg"
                          imperial="lb"
                          className="text-input"
                          tabIndex={tabIndex++}
                          name="load"
                          placeholder="Weight"
                          defaultValue={set.load || ""}
                        />
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="Load-Selector">
                    <div>
                      <input
                        type="radio"
                        tabIndex={tabIndex++}
                        name="loadType"
                        id="load-percent"
                        defaultChecked={preferredLoadInput === "percent"}
                        defaultValue="%"
                      />
                      <label className="radio-input" htmlFor="load-percent">
                        <span className="radio" />
                        <span className="text">% of 1RM</span>
                      </label>
                      <div className="load">
                        <input
                          type="text"
                          tabIndex={tabIndex++}
                          name="percentRepMax"
                          className="text-input"
                          defaultValue={percentRM ? percentRM.toFixed(1) : ""}
                          placeholder="%"
                        />
                      </div>
                    </div>
                    <div>
                      <input
                        type="radio"
                        name="loadType"
                        id="load-weight"
                        defaultChecked={preferredLoadInput === "weight"}
                        defaultValue="weight"
                      />
                      <label className="radio-input" htmlFor="load-weight">
                        <span className="radio" />
                        <span className="text">Weight</span>
                      </label>
                      <div className="load">
                        <UnitInput
                          metric="kg"
                          imperial="lb"
                          className="text-input"
                          tabIndex={tabIndex++}
                          name="load"
                          placeholder="Weight"
                          defaultValue={set.load || ""}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {!isAssistant && (
                <div className="Equipped-Selector">
                  <input
                    type="checkbox"
                    id="equipped-toggle"
                    tabIndex={tabIndex++}
                    name="equipped"
                    defaultChecked={set.equipped}
                  />
                  <div />

                  <div className="column" data-col="2/3">
                    <div className="label">
                      <label className="checkbox" htmlFor="equipped-toggle" />{" "}
                      Equipped
                    </div>
                    <input
                      type="text"
                      name="equipment"
                      placeholder="Equipment"
                      className="text-input"
                      defaultValue={set.equipment}
                    />
                  </div>

                  <div className="column" data-col="1/3">
                    <div className="label">Equipped (RM)</div>
                    <UnitInput
                      min="1"
                      metric="kg"
                      imperial="lb"
                      className="text-input"
                      name="equippedRepMax"
                      placeholder="Weight"
                      defaultValue={(set.equipped && set.equippedRepMax) || ""}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="foot">
            {isNew && (
              <button
                className="button-input"
                tabIndex={tabIndex++}
                value="true"
                name="addAnother"
              >
                Save & add another
              </button>
            )}
            <button className="button-input" tabIndex={tabIndex++}>
              {isNew ? "Save" : "Save Set"}{" "}
            </button>
            <a className="button alt" href="/actions/refresh?modal=">
              Cancel
            </a>
          </div>
        </Modal>
      </form>
    );
  }
}
EditSetsModal.contextTypes = { locals: PropTypes.object };

export default EditSetsModal;
